/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { get } from 'lodash';
import dateFormat from 'dateformat';
import { toast } from 'react-toastify';
import { Calendar } from '../../../components/calendar';
import { Dropdown } from 'primereact/dropdown';
import { ToggleButton } from 'primereact/togglebutton';
import { addLocale } from 'primereact/api';
import { Input100px } from '../../../styles/inputGroup';
import Card from '../../../components/card';
import Loading from '../../loading';
import { formataMoeda, displayErrors, arredondar } from '../../../util/diversos';

import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';

export default function RelatorioEstampariaPedido() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);
  const [findSituacaoPedido, setFindSituacaoPedido] = useState('ABERTO');
  const [resumoMensal, setResumoMensal] = useState(false);

  const [listaSituacaoPedido] = useState([
    { label: 'Aberto', value: 'ABERTO' },
    { label: 'Cancelado', value: 'CANCELADO' },
    { label: 'Fechado', value: 'FECHADO' },
    { label: 'Todos', value: 'TODOS' },
  ]);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });

  addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'hoje',
    clear: 'Limpar',
  });

  function headRows() {
    return [{
      id: 'id',
      nomePedido: 'Pedido',
      cliente: 'Cliente',
      dataPedido: 'Data Pedido',
      dataEntrega: 'Data Entrega',
      situacao: 'Situação',
      valorBruto: 'Valor Bruto',
      valorDesconto: 'Desconto',
      valorTotal: 'Total',
      percentualDesconto: '% Desc.' },
    ];
  }

  function headRowsMensal() {
    return [{
      mes: 'Mês',
      totalBruto: 'Valor Bruto',
      totalDesconto: 'Desconto',
      totalFinal: 'Total',
    }];
  }

  const [headerTabelaImpressao] = useState(headRows());
  const [headerTabelaImpressaoMensal] = useState(headRowsMensal());

  const idUsuario = get(store.getState().auth.user, 'id', 0);

  async function getData(searchFilter, page, size, img) {
    // eslint-disable-next-line new-cap
    try {
      setIsLoading(true);

      if (findDataInicial == null && findDataFinal == null) {
        toast.info('Datas devem ser informadas.');
        return;
      }

      if (findDataInicial > findDataFinal) {
        toast.info('Data final anterior a data inicial.');
        return;
      }

      let params = '';
      let response = null;
      if (resumoMensal) {
        // pega a lista de pedidos no periodo
        params = `/estampariapedido/resumodataquantidadevalordiferentecancelado?idUsuario=${idUsuario}`;
        if (searchFilter && searchFilter.findDataInicial !== '') {
          const _dataInicial = `${dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy')} 00:00:00`;
          const _dataFinal = `${dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy')} 23:59:59`;

          params = `${params}&dataInicial=${_dataInicial}&dataFinal=${_dataFinal}`;
        }
        params = `${params}&situacao=CANCELADO`;

        response = await axiosAdmin.get(params);
      } else {
        params = `/estampariapedido?idUsuario=${idUsuario}`;

        if (searchFilter && searchFilter.findDataInicial !== '') {
          const _dataInicial = `${dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy')} 00:00:00`;
          const _dataFinal = `${dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy')} 23:59:59`;

          params = `${params}&dataInicial=${_dataInicial}&dataFinal=${_dataFinal}`;
        }

        if (searchFilter && searchFilter.findSituacaoPedido !== 'TODOS') {
          params = `${params}&situacao=${searchFilter.findSituacaoPedido}`;
        }

        response = await axiosAdmin.get(params);
      }

      if (response.data <= 0) {
        toast.info('Não há registros a serem exibidos.');
        return;
      }

      if (resumoMensal) {
        // eslint-disable-next-line new-cap
        const doc = new jsPDF();
        let data = {
          mes: '',
          totalBruto: '',
          totalDesconto: '',
          totalFinal: '',
        };

        const result = [];
        const somaBrutoPorMes = {};
        const somaDescontoPorMes = {};
        const somaTotalPorMes = {};
        for (let x = 0; x < response.data.length; x++) {
          const pedido = response.data[x];

          const ano = pedido.data[0];
          const mes = pedido.data[1];

          const chave = `${mes.toString().padStart(2, '0')}-${ano}`;

          // se ainda não existir, começa com 0
          if (!somaBrutoPorMes[chave]) {
            somaBrutoPorMes[chave] = 0;
          }
          somaBrutoPorMes[chave] += pedido.valor + pedido.valorDesconto;

          // se ainda não existir, começa com 0
          if (!somaTotalPorMes[chave]) {
            somaTotalPorMes[chave] = 0;
          }
          somaTotalPorMes[chave] += pedido.valor;

          if (!somaDescontoPorMes[chave]) {
            somaDescontoPorMes[chave] = 0;
          }
          somaDescontoPorMes[chave] += pedido.valorDesconto;
        }

        let totalGeral = 0;
        let anoAtual = null;
        let somaAno = 0;
        let contadorDeAnos = 0;
        if (somaBrutoPorMes) {
          for (const chave in somaBrutoPorMes) {
            const bruto = somaBrutoPorMes[chave];
            const desconto = somaDescontoPorMes[chave];
            const total = somaTotalPorMes[chave];

            // eslint-disable-next-line no-unused-vars
            const [mes, ano] = chave.split('-');

            // se o ano mudou e já havia um ano em andamento
            if (anoAtual && ano !== anoAtual) {
              data = {
                mes: '',
                totalBruto: '',
                totalDesconto: 'Total do Ano / Meses',
                totalFinal: `${formataMoeda(somaAno)}`,
              };
              result.push({ ...data });
              data = {
                mes: '',
                totalBruto: '',
                totalDesconto: '',
                totalFinal: '',
              };
              result.push({ ...data });
              somaAno = 0; // reinicia a soma
              contadorDeAnos++;
            }

            anoAtual = ano;
            somaAno += total;

            data = {
              mes: chave,
              totalBruto: `${formataMoeda(bruto)}`,
              totalDesconto: `${formataMoeda(desconto)}`,
              totalFinal: `${formataMoeda(total)}`,
            };
            totalGeral += total;
            result.push({ ...data });
          }

          if (anoAtual && contadorDeAnos > 0) {
            data = {
              mes: '',
              totalBruto: '',
              totalDesconto: 'Total do Ano / Meses',
              totalFinal: `${formataMoeda(somaAno)}`,
            };
            result.push({ ...data });
          }
        }

        data = {
          mes: '',
          totalBruto: '',
          totalDesconto: '',
          totalFinal: '',
        };

        result.push({ ...data });
        data = {
          mes: '',
          totalBruto: '',
          totalDesconto: 'Total Geral',
          totalFinal: `${formataMoeda(totalGeral)}`,
        };

        result.push({ ...data });
        doc.autoTable({
          styles: { fontSize: 8 },
          margin: { top: 38, left: 5, right: 5 },
          columnStyles: {
            0: { cellWidth: 23 },
          },
          theme: 'grid',
          head: headerTabelaImpressaoMensal,
          body: result,
          didDrawPage: dados => {
            // Header
            doc.rect(5, 5, 200, 30);
            doc.addImage(img, 'JPEG', 9, 8, 25, 25);
            doc.setFontSize(20);
            doc.text('Relatório Demonstrativo Mensal de Pedidos ', 50, 15);

            if (!resumoMensal) {
              doc.setFontSize(8);
              doc.text('Situação:', 50, 27);
              doc.text(findSituacaoPedido, 63, 27);
            }

            doc.setFontSize(8);
            doc.text('Período:', 50, 32);
            doc.text(dateFormat(findDataInicial, 'dd/mm/yyyy'), 63, 32);
            doc.text(' à ', 79, 32);
            doc.text(dateFormat(findDataFinal, 'dd/mm/yyyy'), 83, 32);

            // footer
            const { pageSize } = doc.internal;
            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(`Pag ${doc.internal.getNumberOfPages()}`, dados.settings.margin.right, pageHeight - 8);
            doc.text('Elo Informática Barbacena LTDA', 125, pageHeight - 8);
            const periodo = new Date();
            doc.text('Impresso: ', 262, pageHeight - 8);
            // eslint-disable-next-line prefer-template
            doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + (+periodo.getMonth() + 1)).slice(-2)}/${periodo.getFullYear()}`).toString(), 277, pageHeight - 8);
          },
        });
        window.open(doc.output('bloburl'));
      } else {
        // eslint-disable-next-line new-cap
        const doc = new jsPDF('landscape');
        let data = {
          id: '0',
          nomePedido: '',
          cliente: '',
          dataPedido: '',
          dataEntrega: '',
          situacao: '',
          valorTotal: '',
          valorBruto: '',
          valorDesconto: '',
          percentualDesconto: '',
        };

        const result = [];
        let totalPedidos = 0;
        let totalDesconto = 0;
        let percentualDesconto = 0;
        for (let x = 0; x < response.data.length; x++) {
          data.percentualDesconto = '';
          if (data.valorDesconto == null || data.valorDesconto < 0) {
            data.valorDesconto = 0;
          }
          const pedido = response.data[x];

          data.id = pedido.id.toString();
          data.nomePedido = pedido.nomePedido.toString();
          if (pedido.cliente != null) {
            const id = pedido.cliente.id.toString();
            data.cliente = `${id} - ${pedido.cliente.razaoSocial}`;
          }
          if (pedido.dataPedido !== null) {
            data.dataPedido = `${('00' + pedido.data[2]).slice(-2)}/${('00' + pedido.data[1]).slice(-2)}/${pedido.data[0]}`;
          }
          if (pedido.dataEntrega !== null) {
            data.dataEntrega = `${('00' + pedido.dataEntrega[2]).slice(-2)}/${('00' + pedido.dataEntrega[1]).slice(-2)}/${pedido.dataEntrega[0]}`;
          }

          if (findSituacaoPedido !== 'CANCELADO') {
            data.situacao = pedido.situacao;
            if (pedido.situacao !== 'CANCELADO') {
              data.valorTotal = `${formataMoeda(pedido.valorTotal)}`;
              totalPedidos += pedido.valorTotal;

              data.valorBruto = `${formataMoeda(pedido.valorTotal)}`;
              if (pedido.valorDesconto > 0) {
                data.valorBruto = `${formataMoeda(pedido.valorTotal + pedido.valorDesconto)}`;
                data.valorDesconto = `${formataMoeda(pedido.valorDesconto)}`;
                totalDesconto += pedido.valorDesconto;

                percentualDesconto = pedido.valorDesconto;
                data.percentualDesconto = arredondar((percentualDesconto / (pedido.valorTotal + percentualDesconto)) * 100, 2) + '%';
              } else {
                data.valorDesconto = `${formataMoeda(0)}`;
              }
            } else {
              data.valorTotal = `${formataMoeda(pedido.valorTotal)}`;
            }
          } else {
            data.valorTotal = `${formataMoeda(pedido.valorTotal)}`;
            totalPedidos += pedido.valorTotal;
          }
          result.push({ ...data });
        }

        // adionar linha vazia
        data = {
          id: '',
          nomePedido: '',
          cliente: '',
          dataPedido: '',
          dataEntrega: '',
          situacao: '',
          valorBruto: '',
          valorTotal: '',
          valorDesconto: '',
          percentualDesconto: '',
        };

        data.valorBruto = 'Total';
        data.valorTotal = `${formataMoeda(totalPedidos)}`;
        result.push({ ...data });

        // adionar linha vazia
        data = {
          id: '',
          nomePedido: '',
          cliente: '',
          dataPedido: '',
          dataEntrega: '',
          situacao: '',
          valorBruto: '',
          valorTotal: '',
          valorDesconto: '',
          percentualDesconto: '',
        };

        data.valorBruto = 'Desconto';
        data.valorTotal = `${formataMoeda(totalDesconto)}`;
        data.percentualDesconto = arredondar((totalDesconto / totalPedidos) * 100) + '%';
        result.push({ ...data });

        doc.autoTable({
          styles: { fontSize: 8 },
          margin: { top: 38, left: 5, right: 5 },
          columnStyles: {
            6: { cellWidth: 23 },
            7: { cellWidth: 23 },
            8: { cellWidth: 23 },
            9: { cellWidth: 15 },
          },
          theme: 'grid',
          head: headerTabelaImpressao,
          body: result,
          didDrawPage: dados => {
            // Header
            // doc.rect(5, 5, 200, 30); //retrato
            doc.rect(5, 5, 287, 30); // landiscape
            doc.addImage(img, 'JPEG', 9, 8, 25, 25);
            doc.setFontSize(20);
            doc.text('Relatório de Pedidos ', 115, 15);

            doc.setFontSize(8);
            doc.text('Situação:', 50, 27);
            doc.text(findSituacaoPedido, 63, 27);

            doc.setFontSize(8);
            doc.text('Período:', 50, 32);
            doc.text(dateFormat(findDataInicial, 'dd/mm/yyyy'), 63, 32);
            doc.text(' à ', 79, 32);
            doc.text(dateFormat(findDataFinal, 'dd/mm/yyyy'), 83, 32);

            // footer
            const { pageSize } = doc.internal;
            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(`Pag ${doc.internal.getNumberOfPages()}`, dados.settings.margin.right, pageHeight - 8);
            doc.text('Elo Informática Barbacena LTDA', 125, pageHeight - 8);
            const periodo = new Date();
            doc.text('Impresso: ', 262, pageHeight - 8);
            // eslint-disable-next-line prefer-template
            doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + (+periodo.getMonth() + 1)).slice(-2)}/${periodo.getFullYear()}`).toString(), 277, pageHeight - 8);
          },
        });

        window.open(doc.output('bloburl'));
      }
    } catch (e) {
      // console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal, findSituacaoPedido };

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    const loadImage = async () => {
      let config = '';
      try {
        config = await axiosAdmin.get(`/configuracaosistema?idUsuario=${idUsuario}`);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      }

      const img = new Image();
      img.src = `/logotipos/${config.data.urlLogotipo}`;
      await img.decode().then(() => {

      }).catch(() => {
        img.src = 'logo.png';
      });
      getData(searchFilter, 0, lazyParams.rows, img);
    };
    loadImage();
    // getData(searchFilter, 0, lazyParams.rows);
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}> Relatório Pedido </h6>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Data inicial
              </Input100px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataInicial}
                onChange={(e) => setFindDataInicial(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Data final
              </Input100px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataFinal}
                onChange={(e) => setFindDataFinal(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Situação
              </Input100px>
              <Dropdown
                options={listaSituacaoPedido}
                value={findSituacaoPedido}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setFindSituacaoPedido(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Mensal
              </Input100px>
              <ToggleButton
                onLabel="Sim"
                offLabel="Não"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                checked={resumoMensal}
                onChange={(e) => setResumoMensal(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-1">
            <button
              type="button"
              title="Imprimir"
              className="btn btn-success"
              style={{ borderRadius: '15px' }}
              onClick={handleFind}
            >
              <i className="pi pi-print"></i>
            </button>
          </div>
        </div>
      </Card>
    </>
  );
}
